"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var polished_1 = require("polished");

var em_1 = tslib_1.__importDefault(require("polished/lib/helpers/em"));

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var _utilities_1 = require("../../../utilities");

var Text_1 = tslib_1.__importDefault(require("../FormattedText/Text"));

var OPEN_ALL_EVENT_NAME = 'content-widget-faq-openAll';
var CLOSE_ALL_EVENT_NAME = 'content-widget-faq-closeAll';
var BACKGROUND_COLOR = '#84959e';
var TEXT_COLOR = 'white';
var CONTROL_HEIGHT = 24;
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border: ", " solid ", ";\n  font-size: ", ";\n  position: relative;\n"], ["\n  border: ", " solid ", ";\n  font-size: ", ";\n  position: relative;\n"])), em_1["default"](1), BACKGROUND_COLOR, em_1["default"](13));
var QuestionWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  padding: ", " ", ";\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n"], ["\n  padding: ", " ", ";\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n"])), em_1["default"](5), em_1["default"](15), BACKGROUND_COLOR, TEXT_COLOR);
var AnswerWrapper = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  padding: ", " ", ";\n  border-top: 0;\n  display: none;\n  ", "\n"], ["\n  padding: ", " ", ";\n  border-top: 0;\n  display: none;\n  ", "\n"])), em_1["default"](5), em_1["default"](15), function (_a) {
  var isOpen = _a.isOpen;
  return isOpen && styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      display: block;\n    "], ["\n      display: block;\n    "])));
});
var Controls = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: -", ";\n  right: 0;\n  display: flex;\n  z-index: 1;\n  padding: 0 ", ";\n"], ["\n  position: absolute;\n  top: -", ";\n  right: 0;\n  display: flex;\n  z-index: 1;\n  padding: 0 ", ";\n"])), polished_1.rem(CONTROL_HEIGHT + 1), polished_1.rem(2));
var Control = styled_components_1["default"].button(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  margin: 0 ", ";\n  border-radius: ", "\n    ", " 0 0;\n  cursor: pointer;\n\n  display: inline-flex;\n  width: auto;\n  align-items: center;\n  justify-content: center;\n  outline: 0;\n  border: none;\n  background: ", ";\n  color: ", ";\n  vertical-align: baseline;\n  padding: 0 ", ";\n  text-transform: none;\n  text-shadow: none;\n  font-weight: normal;\n  line-height: 1;\n  font-style: normal;\n  font-size: ", ";\n  text-decoration: none;\n  user-select: none;\n  font-family: ", ";\n\n  transition: background-color 0.1s ease, color 0.1s ease, background 0.1s ease;\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"], ["\n  height: ", ";\n  margin: 0 ", ";\n  border-radius: ", "\n    ", " 0 0;\n  cursor: pointer;\n\n  display: inline-flex;\n  width: auto;\n  align-items: center;\n  justify-content: center;\n  outline: 0;\n  border: none;\n  background: ", ";\n  color: ", ";\n  vertical-align: baseline;\n  padding: 0 ", ";\n  text-transform: none;\n  text-shadow: none;\n  font-weight: normal;\n  line-height: 1;\n  font-style: normal;\n  font-size: ", ";\n  text-decoration: none;\n  user-select: none;\n  font-family: ", ";\n\n  transition: background-color 0.1s ease, color 0.1s ease, background 0.1s ease;\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"])), polished_1.rem(CONTROL_HEIGHT), polished_1.rem(2), function (_a) {
  var theme = _a.theme;
  return theme.largeBorderRadius;
}, function (_a) {
  var theme = _a.theme;
  return theme.largeBorderRadius;
}, polished_1.lighten(0.3, BACKGROUND_COLOR), polished_1.darken(0.1, BACKGROUND_COLOR), polished_1.rem(8), polished_1.rem(11), function (_a) {
  var theme = _a.theme;
  return theme.fontFamily;
}, BACKGROUND_COLOR, TEXT_COLOR);

var WidgetFAQ = function (_a) {
  var _b = _a.data,
      data = _b === void 0 ? {} : _b;

  var _c = react_1["default"].useState(false),
      isOpen = _c[0],
      setIsOpen = _c[1];

  var _d = react_1["default"].useState(false),
      controlsShown = _d[0],
      setControlsShown = _d[1];

  var wrapperEl = react_1["default"].useRef(null);

  var _e = react_1["default"].useState(-1),
      prevScrollPosition = _e[0],
      setPrevScrollPosition = _e[1];

  react_1["default"].useEffect(function () {
    function handleOpenAllEvent() {
      setIsOpen(true);
    }

    function handleCloseAllEvent() {
      setIsOpen(false);
    }

    document.addEventListener(OPEN_ALL_EVENT_NAME, handleOpenAllEvent, false);
    document.addEventListener(CLOSE_ALL_EVENT_NAME, handleCloseAllEvent, false);
    return function () {
      document.removeEventListener(OPEN_ALL_EVENT_NAME, handleOpenAllEvent, false);
      document.removeEventListener(CLOSE_ALL_EVENT_NAME, handleCloseAllEvent, false);
    };
  }, []); // handle scroll back after all FAQs have been opened

  react_1["default"].useLayoutEffect(function () {
    var el = wrapperEl.current;

    if (prevScrollPosition < 0 || !el) {
      return;
    }

    var scrollParent = _utilities_1.getScrollParent(el);

    var top = _utilities_1.getOffsetTopRelativeToParent(el, scrollParent) - prevScrollPosition;
    scrollParent.scroll(0, top);
    setPrevScrollPosition(-1);
  }, [prevScrollPosition]);
  var handleOpenAll = react_1["default"].useCallback(function () {
    var _a;

    var prevPosition = ((_a = wrapperEl.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) || 0;
    var e = new Event(OPEN_ALL_EVENT_NAME);
    document.dispatchEvent(e);
    setPrevScrollPosition(prevPosition);
  }, []);
  var handleCloseAll = react_1["default"].useCallback(function () {
    var _a;

    var prevPosition = ((_a = wrapperEl.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) || 0;
    var e = new Event(CLOSE_ALL_EVENT_NAME);
    document.dispatchEvent(e);
    setPrevScrollPosition(prevPosition);
  }, []);
  return react_1["default"].createElement(Wrapper, {
    ref: wrapperEl,
    onMouseEnter: function () {
      setControlsShown(true);
    },
    onMouseLeave: function () {
      setControlsShown(false);
    }
  }, react_1["default"].createElement(QuestionWrapper, {
    onClick: function () {
      setIsOpen(function (prev) {
        return !prev;
      });
    }
  }, react_1["default"].createElement(Text_1["default"], {
    text: data.question || '<p><br></p>'
  })), react_1["default"].createElement(AnswerWrapper, {
    isOpen: isOpen
  }, react_1["default"].createElement(Text_1["default"], {
    text: data.answer || ''
  })), controlsShown && react_1["default"].createElement(Controls, null, react_1["default"].createElement(Control, {
    onClick: handleOpenAll,
    type: "button"
  }, "+ Rozba\u013E v\u0161etky"), react_1["default"].createElement(Control, {
    onClick: handleCloseAll,
    type: "button"
  }, "- Zba\u013E v\u0161etky")));
};

exports["default"] = react_1["default"].memo(WidgetFAQ);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;